import { render } from "./Courses.vue?vue&type=template&id=7fbbeeb5&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import "./Courses.vue?vue&type=style&index=0&id=7fbbeeb5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7fbbeeb5"

export default script